import { render, staticRenderFns } from "./SkillStubTooltip.vue?vue&type=template&id=642a9f72&scoped=true&"
import script from "./SkillStubTooltip.vue?vue&type=script&lang=ts&"
export * from "./SkillStubTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./SkillStubTooltip.vue?vue&type=style&index=0&id=642a9f72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642a9f72",
  null
  
)

export default component.exports